import type { Rng } from './rng.js';

/**
 * Спутницы: стресс-менеджмент с абонентской платой.
 * Чем выше уровень, тем сильнее снимает нервы и тем дороже содержание —
 * и тем выше нужно Обаяние, чтобы вообще познакомиться.
 */

export interface CompanionTier {
  def: string;
  title: string;
  /** 1 — с района, 3 — модель охуенная. */
  tier: 1 | 2 | 3;
  /** Сколько стресса снимает прогулка. */
  stressRelief: number;
  /** Во сколько встаёт подарок, в копейках. */
  giftPrice: number;
  /** Обаяние, ниже которого даже не подходи. */
  needObayanie: number;
}

export const COMPANION_TIERS: readonly CompanionTier[] = [
  { def: 'sraiona', title: 'С района', tier: 1, stressRelief: 20, giftPrice: 8000, needObayanie: 0 },
  { def: 'uverennaya', title: 'Уверенная в себе', tier: 2, stressRelief: 32, giftPrice: 25000, needObayanie: 8 },
  { def: 'model', title: 'Модель', tier: 3, stressRelief: 45, giftPrice: 60000, needObayanie: 16 },
];

/** Без подарков уходит через трое суток. */
export const COMPANION_PATIENCE_DAYS = 3;

/** Слоты открываются Обаянием: одна с самого начала, дальше по десятке. */
export function companionSlots(obayanie: number, bonusSlots = 0): number {
  return Math.min(3, 1 + Math.floor(obayanie / 10) + bonusSlots);
}

/**
 * Кого удалось зацепить. Обаяние решает и шанс подхода, и потолок уровня:
 * с тройкой обаяния модель не светит, сколько ни ходи на дискач.
 */
export function courtCompanion(rng: Rng, obayanie: number): CompanionTier | null {
  const affordable = COMPANION_TIERS.filter((tier) => obayanie >= tier.needObayanie);
  if (affordable.length === 0) return null;

  // Шанс вообще познакомиться: от четверти на старте до почти верного к 20.
  const chance = Math.min(0.9, 0.25 + obayanie * 0.035);
  if (!rng.chance(chance)) return null;

  // Чем выше обаяние, тем вероятнее верхний из доступных уровней.
  const roll = rng.next() * (1 + obayanie / 12);
  const index = Math.min(affordable.length - 1, Math.floor(roll * affordable.length));
  return affordable[index] ?? null;
}
